import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { InvoiceLinkExpiryType, InvoiceLinkModeType, PlatformConnectionType } from '@/types/invoiceVaultTypes';

export type PlatformSettingsPayloadType = {
  use_default_account?: boolean;
  default_vault_account_id?: string | null;
  default_rail?: string;
  default_mode?: InvoiceLinkModeType;
  default_expiry_code?: InvoiceLinkExpiryType;
  pay_through_wirevault?: boolean;
};

export const getPlatformApi = (): Promise<ApiResponseType<PlatformConnectionType | null>> =>
  authApiService.GET('/invoice-vault/platform/');
export const connectPlatformApi = (payload: {
  platform_name: string;
  api_key_id?: string;
}): Promise<ApiResponseType<PlatformConnectionType>> => authApiService.POST('/invoice-vault/platform/', payload);
export const updatePlatformSettingsApi = (
  payload: PlatformSettingsPayloadType
): Promise<ApiResponseType<PlatformConnectionType>> => authApiService.PATCH('/invoice-vault/platform/', payload);
export const disconnectPlatformApi = (): Promise<ApiResponseType<PlatformConnectionType>> =>
  authApiService.DELETE('/invoice-vault/platform/');
